import React from "react";
import { getVersionUrl } from 'common/cacheOverwrite';

type Proc = {
    url : string;
    title : string;
}

const CardStatusHTML : React.FC<Proc> = ({url , title}) => {
    return (
      <div id="wrap">
        <div id="container" className="pcHidden">
          <section className="contents">
            <div className="inner">
              <div className="section serverWrap">
                <iframe className="cardStatusDetail" allowFullScreen src={getVersionUrl(url)} title={title} />
              </div>
            </div>
          </section>
        </div>
      </div>
    );
}

export default CardStatusHTML;